import { useQuery } from '@tanstack/react-query';

import { DeclarationCustomsType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

interface DeclarationTypeResponse {
  declarationType: string;
  sentTo?: DeclarationCustomsType;
}

export const useGetDeclarationTypeForBatch = ({ batchId }: HookProps) =>
  useQuery({
    queryKey: ['declaration-type', batchId],
    queryFn: async (): Promise<DeclarationTypeResponse> => {
      try {
        const result = await apiClient.declarations.retrieveDeclarationType.query({ query: { batchId } });
        if (result.status !== 200) throw result.body;

        return result.body.data as DeclarationTypeResponse;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration type');
      }
    },
    placeholderData: { declarationType: '' },
  });
